import { render, staticRenderFns } from "./DigiBoardLicenceCounts.vue?vue&type=template&id=147ea81b&scoped=true"
import script from "./DigiBoardLicenceCounts.vue?vue&type=script&lang=js"
export * from "./DigiBoardLicenceCounts.vue?vue&type=script&lang=js"
import style0 from "./DigiBoardLicenceCounts.vue?vue&type=style&index=0&id=147ea81b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147ea81b",
  null
  
)

export default component.exports